module.exports = __webpack_public_path__ + "static/media/dodgem(4).36998d67.PNG";